import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import DetailStuTestHistoryComp from "./Component/DetailStuTestHistoryComp"


const DetailStuTestHistory =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <DetailStuTestHistoryComp />
        </div>
        <Footer />
        </>
    )
}

export default DetailStuTestHistory